// File: src/lang/lang.js
// File: src/lang/lang.js
export const lang = {
  en: {
    heroTitle: "Simplify Your Work with Automation",
    heroSubtitle: "Smart tools for freelancers and professionals. Book your free demo today!",
    bookDemo: "Book a Free Consultation",
    blogPreview: "Latest from our Automation Blog",
    testimonials: "What Our Clients Say",
    contact: "Get in Touch",
    benefits: [
      { icon: "robot", text: "Automate repetitive tasks" },
      { icon: "comments", text: "WhatsApp bots and bookings" },
      { icon: "brain", text: "AI-powered assistants" },
      { icon: "chart", text: "Tool integrations (Google, Meta...)" }
    ]
  },
  fr: {
    heroTitle: "Simplifiez votre travail avec l'automatisation",
    heroSubtitle: "Des outils intelligents pour les freelances et professionnels. Réservez votre démo gratuite aujourd'hui!",
    bookDemo: "Réserver une consultation gratuite",
    blogPreview: "Derniers articles de notre blog d'automatisation",
    testimonials: "Ce que disent nos clients",
    contact: "Nous contacter",
    benefits: [
      { icon: "robot", text: "Automatisez les tâches répétitives" },
      { icon: "comments", text: "Bots WhatsApp et réservations" },
      { icon: "brain", text: "Assistants basés sur l'IA" },
      { icon: "chart", text: "Intégrations (Google, Meta...)" }
    ]
  },
  nl: {
    heroTitle: "Vereenvoudig je werk met automatisering",
    heroSubtitle: "Slimme tools voor freelancers en professionals. Boek vandaag je gratis demo!",
    bookDemo: "Gratis consultatie boeken",
    blogPreview: "Laatste nieuws van onze automatiseringsblog",
    testimonials: "Wat onze klanten zeggen",
    contact: "Neem contact op",
    benefits: [
      { icon: "robot", text: "Automatiseer repetitieve taken" },
      { icon: "comments", text: "WhatsApp-bots en boekingen" },
      { icon: "brain", text: "AI-gestuurde assistenten" },
      { icon: "chart", text: "Integraties met tools (Google, Meta...)" }
    ]
  }
};
